import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../Common";
import services from "../services";
import authService from "../../Common/services";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Joi from "@hapi/joi";
import { TagPrintSchema } from "../TagPrintSchema"
import { validateProperty, validate } from "../../Common";
import MessageModal from "../../../UI/Modal/MessageModal";
import tokenService from "../../../Common/tokenDecoder";
import Barcode from 'react-barcode';
import QRCode from "react-qr-code";
import Checkbox from '@material-ui/core/Checkbox';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import { Button } from "@material-ui/core";

const screenCode = "TAGPRINT";

export function TagPrint(props) {
  const [groups, setGroups] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [haverstingJobType, setHaverstingJobType] = useState([]);
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const [istableHidden, setIstableHidden] = useState(true);
  const [qrTagDetails, setQrTagDetails] = useState([]);
  const [saveData, setSaveData] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed successfuly.",
  });
  const [qrTag, setQRTag] = useState({
    groupID: "0",
    operationEntityID: "0",
    routeID: "0",
    employeeTypeID: "0",
    haverstingJobTypeID: "0",
  });

  const componentRef = useRef();

  const selectAll = () => {
    setCheckAll(!checkAll);
  };

  const schema = Joi.object(TagPrintSchema).options({ allowUnknown: true });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    if (qrTag.groupID != 0 || qrTag.groupID != "") {
      trackPromise(getOperationEntityByGroup());
    }
  }, [qrTag.groupID]);

  useEffect(() => {
    trackPromise(
      getAllRoutesForDropDown(),
      getEmployeeTypesForDropdown()
    )
  }, [qrTag.operationEntityID]);

  useEffect(() => {
    getHaverstingEmployeeTypesForDropdown()
  }, [qrTag.employeeTypeID]);

  useEffect(() => {
    setHaverstingJobType([])
    setQrTagDetails([])
  }, [qrTag.groupID, qrTag.operationEntityID, qrTag.routeID, qrTag.employeeTypeID, qrTag.haverstingJobTypeID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find((p) => p.permissionCode == "VIEWTAGPRINT");

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();

    setQRTag({
      ...qrTag,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityByGroup() {
    const data = await services.getOperationEntityByGroup(qrTag.groupID);
    setOperationEntity(data);
  }

  async function getAllRoutesForDropDown() {
    const routeList = await services.getAllRoutesByFactoryID(qrTag.operationEntityID);
    setRoutes(routeList);
  }

  async function getEmployeeTypesForDropdown() {
    const result = await services.getEmployeeTypesData();
    setEmployeeTypes(result);
  }

  async function getHaverstingEmployeeTypesForDropdown() {
    const result = await services.getHaverstingJobTypeByEmployeeTypeID(qrTag.employeeTypeID);
    setHaverstingJobType(result);
  }

  async function handleGenerate(e) {
    e.preventDefault();

    const errorMessages = validate(schema, qrTag);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});

    if (errorMessages) return;
    let model = {
      groupID: parseInt(qrTag.groupID),
      operationEntityID: parseInt(qrTag.operationEntityID),
      routeID: parseInt(qrTag.routeID),
      employeeTypeID: parseInt(qrTag.employeeTypeID),
      haverstingJobTypeID: parseInt(qrTag.haverstingJobTypeID),
    }

    const response = await services.getTags(model);
    if (response.length !== 0) {
      setQrTagDetails(response);
      setIstableHidden(false);
    } else {
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: errorMessages,
        disciption: "No Record to display",
      });
      setIstableHidden(true);
      setTimeout(() => {
        setMessageModel({ ...messageModel, hidden: true })
      }, 1500);
    }
  }

  async function handleSave(e) {
    if (saveData.length > 0) {
      const response = await services.printQRtags(saveData);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });

      if ((response.statusCode = true)) {
        setQrTagDetails([]);
        setIstableHidden(true);
        setTimeout(() => {
          setMessageModel({ ...messageModel, hidden: true })
        }, 150);
      }
    }
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, TagPrintSchema);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];
    setErrors(error);
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      groupID: target.value,
      operationEntityID: "0",
      routeID: "0",
      noOfCodes: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      operationEntityID: target.value,
      routeID: "0",
      noOfCodes: "0",
    });
  }

  function handleChange(e) {
    e.preventDefault();

    const target = e.target;
    const value = target.value;

    const error = { ...errors };
    const errorMessage = validateProperty(target, TagPrintSchema);
    errorMessage ? error[target.name] = errorMessage : delete error[target.name];

    setQRTag({
      ...qrTag,
      [e.target.name]: value
    })
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function checkData(row) {
    let sd = (!(saveData.find((x) => x.tagNo === row.tagNo) == undefined))
    return sd;
  }

  function handleClick(data) {
    let collectionTagData = {
      tagNo: data.tagNo
    };

    let dataRecords = [...saveData];

    var isEnable = dataRecords.find((p) => p.tagNo == data.tagNo);
    if (isEnable === undefined) {
      dataRecords.push(collectionTagData);
    } else {
      var index = dataRecords.indexOf(isEnable);
      dataRecords.splice(index, 1);
    }
    setSaveData(dataRecords);
  }

  function handleClickAll(e) {
    var tagDataCopy = [...saveData];
    if (e.target.checked) {

      qrTagDetails.forEach((x) => {
        let collectionTagData = {
          tagNo: x.tagNo
        };

        var isEnable = tagDataCopy.find((p) => p.tagNo == x.tagNo);
        if (isEnable === undefined) {
          tagDataCopy.push(collectionTagData);
        }
      });
      setSaveData(tagDataCopy);
    } else {
      setSaveData([]);
    }
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Tag Print"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form
                onSubmit={(e) => trackPromise(handleGenerate(e))}
                disabled={false}
              >
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={qrTag.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="operationEntityID"
                      id="operationEntityID"
                      name="operationEntityID"
                      value={qrTag.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(operationEntity)}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="routeID">Division </InputLabel>
                    <Select
                      fullWidth
                      id="routeID"
                      name="routeID"
                      value={qrTag.routeID}
                      onChange={(e) => handleChange(e)}>
                      <MenuItem value="0">--Select Division--</MenuItem>
                      {generateDropDownMenu(routes)}
                    </Select>
                    {errors["routeID"] && <FormHelperText error>{errors["routeID"]}</FormHelperText>}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="employeeTypeID">Employee Type </InputLabel>
                    <Select
                      fullWidth
                      id="employeeTypeID"
                      name="employeeTypeID"
                      value={qrTag.employeeTypeID}
                      onChange={(e) => handleChange(e)}>
                      <MenuItem value="0">--Select Employee Type--</MenuItem>
                      {generateDropDownMenu(employeeTypes)}
                    </Select>
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="haverstingJobTypeID">Harvesting Job Type </InputLabel>
                    <Select
                      fullWidth
                      id="haverstingJobTypeID"
                      name="haverstingJobTypeID"
                      value={qrTag.haverstingJobTypeID}
                      onChange={(e) => handleChange(e)}>
                      <MenuItem value="0">--Select Harvesting Job Type--</MenuItem>
                      {generateDropDownMenu(haverstingJobType)}
                    </Select>
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Generate"
                  />
                </div>
              </form>
              <div hidden={istableHidden} >
                <table id="blockWeighment" className="display dataTable no-footer">
                  <thead>
                    <tr>
                      <th align="center">Tags Number</th>
                      <th align="center">
                        <Checkbox
                          color="primary"
                          onClick={(e) => handleClickAll(e)}
                          onChange={selectAll}
                          checked={
                            qrTagDetails.length != 0 && saveData.length == qrTagDetails.length
                          }
                        ></Checkbox>
                        Select</th>
                      <th align="center">QRCode and BarCode</th>
                    </tr>
                  </thead>
                  <tbody>
                    {qrTagDetails.map((row) => (
                      <tr key={row.tagNo}>
                        <td align="left">{row.tagNo}</td>
                        <td align="center">
                          <Checkbox
                            color="primary"
                            checked={checkData(row)}
                            onChange={() => handleClick(row)}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />
                        </td>
                        <td align="center" style={{ height: "100px" }}>
                          <tr align="center">
                            <QRCode
                              style={{ height: "auto", maxWidth: "70px" }}
                              value={row.tagNo}
                            />
                          </tr>
                          <tr align="center">
                            <Barcode width={1} height={30} value={row.tagNo} />
                          </tr>
                        </td>
                      </tr>
                    ))
                    }
                  </tbody>
                </table>
                <div className="card-footer" align="right">
                  <ReactToPrint
                    documentTitle={"Tags"}
                    trigger={() =>
                      <Button
                        color="primary"
                        id="btnRecord"
                        type="submit"
                        variant="contained"
                        style={{ marginRight: '1rem', }}
                        disabled={saveData.length != 0 ? false : true}
                      >
                        Print
                      </Button>}
                    onAfterPrint={(e) => handleSave(e)}
                    content={() => componentRef.current}
                  />
                  <div hidden={true}>
                    <CreatePdf ref={componentRef} qRTagsDetailsList={saveData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}
